import { Avatar, Box, Button, styled, Typography } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const Container = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledAvatar = styled(Avatar)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "120px",
  height: "120px",
  background: "#242424",
  flex: "none",
  order: "0",
  flexGrow: "0",
  zIndex: "0",
  borderRadius: "50%",
});

export const UserName = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: FONT_FAMILY,
  fontStyle: "normal",
  fontWeight: "700",
  fontSize: "30px",
});

export const UserDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  fontFamily: FONT_FAMILY,
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "17px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    textAlign: "left",
  },
}));

export const SendMessageButton = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "150px",
  borderRadius: "8px",
  backgroundColor: APP_COLOR,
});

export const ContainedButton = styled(Button)({
  backgroundColor: APP_COLOR,
  textTransform: "none",
  borderColor: APP_COLOR,
  "&:hover": {
    borderColor: APP_COLOR,
    backgroundColor: APP_HOVER_COLOR,
  },
});

export const ButtonText = styled(Typography)({
  fontFamily: FONT_FAMILY,
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
});

export const UserDetailsRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  margin: "50px 20px 20px 20px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export const ProfilePicContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "20px",
  },
  [theme.breakpoints.up("sm")]: {
    marginRight: "10px",
  },
}));

export const SkillsGenreContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",

  [theme.breakpoints.down("sm")]: {
    marginBottom: "10px",
    alignItems: "center",
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: "10px",
    alignItems: "flex-start",
  },
}));

export const styles = {
  bioText: { wordBreak: "break-word", lineHeight: "0.6" } as const,
  highlightButton: { backgroundColor: "#27B6CB", color: "black" } as const,
  pageTitlesActive: {
    color: APP_COLOR,
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: "16px",
    fontWeight: "bold",
  } as const,
  pageTitlesDeactive: {
    color: "white",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: "16px",
    fontWeight: "bold",
  } as const,
};
